module.exports = __webpack_public_path__ + "static/app-icon-mdx-1024-a27b0fa0bbfc9e880668ed71515b8cbc.png";